<template>
  <div>
    <div
      :class="{
        blur: $store.$state.modal.name,
        height:
          !pageDetector.isParticipantsPage && !pageDetector.isMatchingEventsPage && !pageDetector.isMarriagesPage && !pageDetector.isDatingEventsPage
      }"
      class="contentLayer"
    >
      <slot />
    </div>
    <modal-router v-if="$store.$state.modal.name" />
    <div id="modal-root"></div>
  </div>
</template>

<script>
import PageDetector from '@/utils/PageDetector'
import useABTestV2 from '@/utils/abtest/useABTestV2'
import { ISSUE_434_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'
import { ISSUE_434_SESSION_START } from '@/utils/constants/gaCustomEventSet'
import GTM from '@/utils/tracking/gtm'

const ModalRouter = defineAsyncComponent(() => import('@/components/ModalRouter.vue'))
const BREAK_POINT = 960
export default {
  components: { ModalRouter },
  computed: {
    pageDetector() {
      return new PageDetector(this.$route)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()

    // issue-434: ABテストパターン判定とセッション開始GAイベント発火
    const { isAPattern, isBPattern } = useABTestV2(ISSUE_434_AB_TEST_CONFIG)
    let issue434Pattern = null
    if (isAPattern) issue434Pattern = 'A'
    else if (isBPattern) issue434Pattern = 'B'

    if (issue434Pattern) {
      this.$store.SET_STATE({ key: 'issue_434_ab_test_pattern', value: issue434Pattern })
      GTM.sendEventToGa({
        category: 'issue',
        action: ISSUE_434_SESSION_START.action,
        label: issue434Pattern
      })
    }
  },
  unmounted() {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onScroll() {
      this.$store.SET_STATE_BY_PATH({ path: ['window', 'old_scroll_top'], value: this.$store.$state.window.scroll_top })
      this.$store.SET_STATE_BY_PATH({ path: ['window', 'scroll_top'], value: window.pageYOffset })
    },
    onResize() {
      this.$store.SET_STATE_BY_PATH({ path: ['window', 'inner_width'], value: window.innerWidth })
      this.$store.SET_STATE({ key: 'pc', value: window.innerWidth >= BREAK_POINT })
      this.$store.SET_STATE({ key: 'sp', value: window.innerWidth < BREAK_POINT })
    }
  }
}
</script>

<style lang="scss" scoped>
.contentLayer {
  display: flex;
  flex-direction: column;
  transition: 0.2s;
  &.blur {
    filter: blur(5px);
  }
  &.height {
    min-height: 100vh;
  }
}
</style>
